import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';


import './Background.scss';
import { Config } from '../../../config';

import { useDispatch, useSelector } from 'react-redux';
import { selectBackgroundAction } from '../../../redux/medias/mediaActions';

import { container } from 'tsyringe';
import { ApiService } from '../../../services/api-service';
import { MediaService } from '../../../services/media-service';
import { AssetManagementService } from '../../../services/asset-management-service';

import { getOffset, useSharedState } from '../../../utils/helpers';
import { Media, MediaOrigin, MediaType } from '../../../models/mediaClass';

import * as R from 'ramda';

import Lottie from 'react-lottie-player'
import lottieJson from '../../../assets/lottie/loading_spinner.json';
import { ReactComponent as MenuSvg} from '../../../assets/icons/icon-three-dots.svg';

import ContextualMenu from './ContextualMenu';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import InlineEdit from '../../utils/InlineEdit';
import NewLabel from '../../newLabel/NewLabel';
import UploadAssetFile from './uploadAssetFile';

import { UNSELECT_MEDIA } from '../../../redux/medias/mediaReducer';
import { ActionType, GroupType } from '../../../models/actionClass';
import { SoundKey, SoundService } from '../../../services/sound-service';


export interface BackgroundProps {
  bg: Media;
}


const Background = (props: BackgroundProps) => {

  const {bg} = props;
  const contextualMenuRef = useRef(undefined);

  const [apiService] = useState(container.resolve(ApiService));
  const [mediaService] = useState(container.resolve(MediaService));
  const [soundService] = useState(container.resolve(SoundService));

  const [backgrounds] = useSharedState(mediaService.backgrounds$);

  const [selectedBgLayer, setSelectedBgLayer] = useSharedState(apiService.selectedBackground$);
  const bgInstance = useSelector((state: any) => state.media.background);
  const dispatch = useDispatch();

  const [isMenuOpened, setMenuOpened] = useState(false);
  const [isRenaming, setIsRenaming] = useState(false);

  const [showBackground4, setShowBackground4] = useState(true);



  useOnClickOutside(contextualMenuRef, () => {
    setMenuOpened(false);
  });


  useEffect(() => {
    if (showBackground4 && bg.id === 'ea06ad33-c637-46c1-b681-63666bc79a04') {
      setShowBackground4(false);
      onSelect(bg);
    }
  }, [])


  useEffect( () => {
    if (selectedBgLayer) {

      // find layerid in backgrounds list
      const bg = R.clone(backgrounds.find(p => p.id === selectedBgLayer.sourceId));
      if (bg && !IsSelected(bg.id)) {
        dispatch(selectBackgroundAction(bg));
      }

    } else {
      // no bg selected (use BG_IMAGE type as default)
      dispatch({type: UNSELECT_MEDIA, payload: MediaType.BG_IMAGE})
      mediaService.unselect(MediaType.BG_IMAGE, null);
    }
  }, [selectedBgLayer]);


  const focusRename = () => {
    setMenuOpened(false);
    setIsRenaming(true);
  }

  const IsSelected = (id) => {
    if (!bgInstance) {
      return false;
    }
    return (bgInstance.id === id);
  }

  const onSelect = (bg) => {
    if (IsSelected(bg.id)) {
      // already selected => do nothing
      return;
    }

    setSelectedBgLayer(
      {
        number: 0,
        type: bg.type,
        sourceUrl: bg.type === MediaType.BG_IMAGE ? bg.source : (MediaType.BG_VIDEO ? bg.mp4 : ''),
        sourceId: bg.id,
        sourceName: "background",
        isHidden: false,
        isSpotted: false,
        liveRank: 1,
        position: {
          x: 0,
          y: 0,
          width: 1,
          height: 1
        },
        crop: { top: 0, left:0, bottom: 1, right: 1}
      }
    );

    mediaService.select(bg.type, bg.id);

    dispatch(selectBackgroundAction(bg));
    apiService.updateReason = {group: bg.type === MediaType.BG_IMAGE ? GroupType.BG_IMAGE : GroupType.BG_VIDEO, action: ActionType.SELECT, value: bg};
    apiService.saveChannel('backgrounds');
  }

  const onHide = (bg) => {
    // if (!IsSelected(bg.id)) {
    //   return;
    // }
    // const action = selectBackgroundAction({type: '', source: ''});
    // dispatch(action);

    setSelectedBgLayer(null);
    mediaService.unselect(bg.type, bg.id);
    dispatch({type: UNSELECT_MEDIA, payload: bg.type})

    apiService.updateReason = {group: bg.type, action: ActionType.UNSELECT, id: bg.id};
    apiService.saveChannel('background');
  }

  const renameBg = (newName) => {
    setIsRenaming(false);
    console.log('new logo name:' , newName);

    setTimeout(() => {
      bg.name = newName;
      bg.isNew = true;
      mediaService.save(bg.type, bg);
      apiService.updateReason = {group: bg.type, action: ActionType.RENAME, value: bg};
      apiService.saveChannel('background');
    }, 100);
  }

  const deleteBg = () => {

    // hide this logo from selected list
    onHide(bg);
    setMenuOpened(false);

    mediaService.remove(bg.type, bg.id, bg.origin);

    apiService.updateReason = {group: bg.type, action: ActionType.REMOVE, id: bg.id};
    apiService.saveChannel('background');

    soundService.playSoundStart(SoundKey.Trash)
  }

  const runMenuClose = () => {
    // console.log('scroll runMenuClose');
    setMenuOpened(false);
  }

  // Add event listeners
  useLayoutEffect(() => {
    if (isMenuOpened) {
      // console.log('set scroll listener');
      window.addEventListener("scroll", runMenuClose, true);
    }

    // Remove event listeners on cleanup
    return () => {
      // console.log('remove scroll listener');
      window.removeEventListener("scroll", runMenuClose, true);
    };
  }, [isMenuOpened]);



  let top, left = 0;

  if (isMenuOpened) {

    const backgroundDiv = document.getElementById('menubg-' + bg.id);
    if (backgroundDiv) {
      const position = getOffset(backgroundDiv);
      left = position.left - 64;
      top = position.top - 70;
    }
  }

  return (
    <>
      <div className="container">
        <div className="img" style={{ backgroundImage: `url(${bg.source})`}} onClick={() => IsSelected(bg.id) ?  onHide(bg) : onSelect(bg)}></div>
        { IsSelected(bg.id) ?
          <div className="action selected"></div>
          :
          <div className="action unselected"></div>
        }
        { bg.type === MediaType.BG_VIDEO &&
          <div className="tick-video"></div>
        }
        <div className="name">
          <InlineEdit
          height={18}
          key={bg.name}
          text={bg.name}
          placeHolder="&middot;&middot;&middot;"
          focused={isRenaming}
          onSetText={(text) => renameBg(text)}
          onDiscard={() => setIsRenaming(false)} />
        </div>
      </div>
      <div className="button-more"  id={'menubg-' + bg.id} ref={contextualMenuRef}>
        <MenuSvg className="menu-icon" onClick={() => setMenuOpened(!isMenuOpened)}/>
        {isMenuOpened &&
          <ContextualMenu onRename={focusRename} onDelete={deleteBg} style={{top, left}}></ContextualMenu>
        }
      </div>
      { bg.isNew &&
        <NewLabel type={'label-background'}></NewLabel>
      }
    </>
  )
}

const Backgrounds = () => {

  const [mediaService] = useState(container.resolve(MediaService));
  const [backgrounds] = useSharedState(mediaService.backgrounds$);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [isFileFailed, setIsFileFailed] = useState(false);
  const [isFileError, setIsFileError] = useState(false);

  const [uploadPercentage, setUploadPercentage] = useState('');


  // assets
  const [assetsService] = useState(container.resolve(AssetManagementService));
  const [uploadAssetKey, setUploadAssetKey] = useSharedState(assetsService.uploadAssetKey$);

  const [showLess, setShowLess] = useState(true);
  const maxLessLength = 6;

  const clearAndUpload = () => {
    setIsFilePicked(false);
    setIsFileFailed(false);
    setIsFileError(false);
    setSelectedFile(null);

    // give time for ADD btn to be redisplayed
    setTimeout(() => {
      const fileAdd = document.getElementById('file-upload-BACKGROUND');
      if (fileAdd) {
        fileAdd.click();
      }
    }, 100);
  }

  const uploadStarted = (file) => {
    setIsFileFailed(false);
    setIsFileError(false);
    setSelectedFile(file);
    setIsFilePicked(true);
  }

  const uploadProgress = (percent) => {
    setUploadPercentage(percent == 0 ? '' : Math.floor(percent) + '%');
  }

  const uploadCompleted = () => {
    mediaService.refresh(MediaType.BACKGROUND);
    setSelectedFile(null);
    setUploadPercentage('100%');
    // setIsFilePicked(false);
  }

  const uploadFailed = () => {
    setIsFileFailed(true);
  }

  const fileError = () => {
    setIsFilePicked(true);
    setIsFileError(true);
    setIsFileFailed(true);
  }

  // // uncomment to have always bg0 as default background
  // if (!layout.background.id) {
  //   onSelect(background[0]);
  // }

  let lessFiltered = showLess ? R.clone(backgrounds).slice(0,maxLessLength) : R.clone(backgrounds);

  useEffect(() => {

    if (uploadAssetKey) {
      // check if backgrounds now contains uploadAssetKey
      const media = backgrounds.find(b => b.id === uploadAssetKey);
      if (media) {
        // remove file upload animation
        setIsFilePicked(false);
        setUploadAssetKey(null);
      }
    }

    lessFiltered = showLess ? R.clone(backgrounds).slice(0,maxLessLength) : R.clone(backgrounds);
    console.log('backgrounds updated', backgrounds, lessFiltered);
  }, [backgrounds, showLess]);

  return (
    <div className="Backgrounds">
      <UploadAssetFile mediaType={MediaType.BACKGROUND} accept={'.jpg, .jpeg, .png, .mp4, .mov, .ogv'} uploadStarted={uploadStarted} uploadProgress={uploadProgress} uploadCompleted={uploadCompleted} uploadFailed={uploadFailed} fileError={fileError}></UploadAssetFile>

      <ul className="backgrounds">
        {isFilePicked &&
          <li key="loading" className="background">
            <div className="container">
              {!isFileFailed ?
              <>
                <div className="img" style={{background: "#f0f0f0"}}>
                  <Lottie loop animationData={lottieJson} play style={{ width: "100%", height: "100%"}} />
                </div>
                <div className="percentage">{uploadPercentage}</div>
                <div className="name">{selectedFile?.name}</div>
              </>
              :
                isFileError ?
                <>
                <div className="img file-error" style={{background: "rgba(255, 51, 121, 0.05)", border: "dashed 1px #e01e5a"}} onClick={() => clearAndUpload()}>
                </div>
                </>
                :

                <>
                  <div className="img failed-upload" style={{background: "rgba(255, 51, 121, 0.05)", border: "dashed 1px #e01e5a"}} onClick={() => clearAndUpload()}>
                  </div>
                  <div className="name failed">Failed - click to retry!</div>
                </>
              }
            </div>
          </li>
        }
        {
          lessFiltered.map( b => {
            return (<li key={b.id} className="background">
              <Background bg={b}></Background>
            </li>)
          })
        }
      </ul>
      { isFileError &&
        <div className="explain-error">
          Supported formats: JPEG, PNG for images. Max file size : 20MB<br/>
          MP4, OGV, MOV for videos. Max file size: 3MB
        </div>
      }
      { backgrounds.length > 6 ?
        (showLess ?
          <div className="show-action show-less" onClick={() => setShowLess(false)}>Show More</div>
          :
          <div className="show-action show-more" onClick={() => setShowLess(true)}>Show Less</div>
        )
      : <></>
      }
      { backgrounds.length === 0 &&
        <div className="empty">No medias available! Press &ldquo;+&rdquo; to add one.</div>
      }

    </div>
  );
}

export default Backgrounds;
